import { BODY_DEFINITIONS } from './body-registry';

export const BODY_SPIN_RATES = BODY_DEFINITIONS.map(body => body.spinRate);

export const BODY_SPIN_OFFSETS = BODY_DEFINITIONS.map(body => body.spinOffset);

export const BODY_SEASON_PHASES = BODY_DEFINITIONS.map(body => body.seasonPhase);

export function bodySpinAngle(slot: number, simulationTime: number): number {
  return (
    simulationTime * (BODY_SPIN_RATES[slot] ?? 0.15) +
    (BODY_SPIN_OFFSETS[slot] ?? 0)
  );
}

export function bodySeasonSignal(slot: number, orbitAngle: number): number {
  return Math.sin(orbitAngle + (BODY_SEASON_PHASES[slot] ?? 0));
}
